import React, { FC, useState } from "react";
import { useRouter } from "next/router";
import { useIntl } from "react-intl";
import { List, Modal } from "antd";
import { CheckOutlined, GlobalOutlined } from "@ant-design/icons";

export const LocaleSelection: FC = () => {
  const { formatMessage } = useIntl();

  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const router = useRouter();
  const { locales, pathname, asPath, query, locale } = router;
  return (
    <>
      <div
        style={{ color: "white", cursor: "pointer" }}
        onClick={() => setModalOpen(true)}
      >
        {formatMessage({ id: `locale.${locale}` })}
        <GlobalOutlined
          style={{ cursor: "pointer", fontSize: "1.4em", marginLeft: 16 }}
        />
      </div>
      <Modal
        open={modalOpen}
        centered
        onCancel={() => setModalOpen(false)}
        footer={false}
        title={formatMessage({ id: "select.language" })}
      >
        <List
          dataSource={locales}
          renderItem={(availableLocale) => (
            <List.Item
              style={{ cursor: "pointer" }}
              onClick={() => {
                router.push({ pathname, query }, asPath, {
                  locale: availableLocale,
                });
                setModalOpen(false);
              }}
            >
              {formatMessage({ id: `locale.${availableLocale}` })}
              {locale === availableLocale && (
                <CheckOutlined style={{ float: "right" }} />
              )}
            </List.Item>
          )}
        />
      </Modal>
    </>
  );
};
